<template>
  <tr
    :class="{
      'tr-hightlight': $store.state.bill.selectedItem == item,
      'tr-commission': isCommission,
      'tr-mixer': isMixer,
      }"
    v-if="itemShow"
    @click.prevent="onClick">
    <td>{{ itemQty }}</td>
    <td
      :class="{'td-mixer-name': isMixer}">
      {{ itemName }}
    </td>
    <td v-if="view != 'modal' && view != 'split'">{{ itemStaff }}</td>
    <td>{{ itemPrice }}</td>
    <td>{{ itemTotal }}</td>
    <td v-if="itemIndex >= 0">
      <span v-if="view !== 'previous' && !isCommission && $route.path === '/order'">
        <i class="icon-remove" @click.stop="removeBillItem"></i>
      </span>
    </td>
  </tr>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import {
  SET_MESSAGE_MODAL, TOGGLE_ORDER_LEVEL_BUTTON
} from '@/store/mutation-types';
import { constant } from '@/utils/helper';
export default {
  name: 'BillItem',
  props: ['item', 'view', 'showStaff', 'itemIndex'],
  computed: {
    itemShow() {
      if(this.view == 'modal'
          && this.isMixer
          && this.itemPrice === '') return false;
      if(this.view == 'modal'
          && this.isCommission
          && !this.item.commissionShowBill) return false;
      return true;
    },
    itemName() {
      const product = this.getObject(this.item.product, 'articles');
      if(!product) return '';
      const productId = this.getArticleProperty(product, 'id', this.cloneList);
      if(!productId) return '';
      if(this.isNormal) return this.printName(productId, 'articles');
      if(this.isMixer) return '+' + this.printName(productId, 'articles');
      if(this.isCommission) {
        const staff = this.getObject(this.item.staff, 'staffs');
        return this.$gettext('Staff #') + staff.ref + ' - ' + staff.firstName;
      }
    },
    itemStaff() {
      return ((this.item == this.getFirstNormalItem)
                || this.showStaff)
              ? this.printProperty(this.item.staff, 'staffs', 'ref')
              : '';
    },
    itemQty() {
      return this.item.qty;
    },
    itemPrice() {
      let price = 0;
      if(this.isNormal) price = parseFloat(this.item.price) + Math.abs(this.itemCommission);
      if(this.isMixer) price = parseFloat(this.item.price);
      if(!price && !this.item.promotion) return '';
      return this.$options.filters.currency(parseFloat(price), true);
    },
    itemTotal() {
      let total = 0;
      if(this.isNormal) total = parseFloat(this.item.total) + this.itemTotalCommission;
      if(this.isMixer) total = parseFloat(this.item.total);
      if(!total && !this.item.promotion) return '';
      return this.$options.filters.currency(parseFloat(total), true);
    },
    itemCommission() {
      const mode = (this.view == 'modal' || this.view == 'previous') ? 'old' : 'new';
      const commission = this.getCommissionOfItem(this.item, mode);
      if(!commission) return 0;
      if(!this.isItemPromotionInvincible && !commission.commissionIncludePrice) {
        return 1*commission.price;
      }
      return 0;
    },
    isItemPromotionInvincible() {
      const promotion = this.item.promotion 
                        ? this.$store.getters.getArray('promotions')
                          .find(promotion => promotion.name == this.item.promotion)
                        : null;
      let isPromotionInvincible = false;
      if(promotion
        && promotion.promotionType == constant.PROMOTION.FREE_ALL
      ) {
        isPromotionInvincible = true;
      }
      return isPromotionInvincible;
    },
    itemTotalCommission() {
      const mode = (this.view == 'modal' || this.view == 'previous') ? 'old' : 'new';
      const commission = this.getCommissionOfItem(this.item, mode);
      if(!commission) return 0;
      if(!this.isItemPromotionInvincible && !commission.commissionIncludePrice) {
        return 1*commission.total;
      }
      return 0;
    },
    isNormal() {
      return this.item.type == this.NORMAL_ITEM;
    },
    isMixer() {
      return this.item.type == this.MIXER_ITEM;
    },
    isCommission() {
      return this.item.type == this.COMMISSION_ITEM;
    },
    isTimer() {
      return this.isTimerArticle(this.item.product);
    },
    cloneList() {
      return this.$store.getters.getCloneArticleList;
    },
    ...mapState({
      orderLevels: state => state.article.orderLevels,
      bill: state => state.bill.bill,
      isCreditBackButtonActive: state => state.toggle.isCreditBackButtonActive,
    }),
    ...mapGetters(
      [
        'getFirstNormalItem',
        'getCommissionOfItem',
        'isTimerArticle',
        'getArticleProperty'
      ]
    ),
  },
  methods: {
    onClick () {
      if(this.view == 'previous') {
        this.creditBack();
      } else if(this.view == 'normal') {
        this.selectItem();
      }
      if (this.isTimer && !this.isCreditBackButtonActive ) {
        this.selectItem();
        this.$router.push({ name: 'change-time' });
      }
    },
    creditBack() {
      if (!this.isCreditBackButtonActive 
          || this.item.qty < 0
      ) return;

      if (this.item.type == this.COMMISSION_ITEM) return;

      if (this.$store.getters.articleBillQuantity(this.item) <= 0) {
        this.$store.commit(
          SET_MESSAGE_MODAL, 
          this.$gettext('Cannot credit back more')
        );
        return;
      }

      const article = this.getObject(this.item.product, 'articles');
      const promotionItem = (this.item.promotion) ? this.item : null;

      const commissionItem = this.$store.getters.getCommissionOfItem(this.item, 'old');
      if(commissionItem) {
        this.$store.getters.addArticle(article, true, null, this.item.price);
        this.$store.getters.addCreditBackCommission(commissionItem);
      } else {
        if(this.$store.getters.isTimerArticle(article.id)) {
          this.$store.getters.addArticle(article, true, promotionItem, null, this.item.qty, this.item.total);
        } else if(article.variablePrice){
          this.$store.getters.addArticle(article, true, promotionItem, this.item.price);
        } else {
          this.$store.getters.addArticle(article, true, promotionItem);
        }
      }
    },
    selectItem() {
      if (this.item.qty >= 0) {
        this.$store.state.bill.selectedItem = this.item;
      }
    },
    removeBillItem() {
      this.$store.state.bill.selectedItem = { empty: true };
      this.$store.getters.removeBillItem(this.item);
    }
  }
};
</script>
